import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { MatCardModule } from '@angular/material/card';
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerModule, NgxSpinnerService } from "ngx-spinner";
import { TitleTextPipe } from "../../../custom.pipe";
import { ApiService } from "../../../api.service";

@Component({
  selector: "app-message",
  standalone: true,
  imports: [MatCardModule,
    CommonModule,TitleTextPipe,NgxSpinnerModule
  ],
  templateUrl: "./message.component.html",
  styleUrls: ["./message.component.scss"]
})

export class MessageComponent implements OnInit {
  @Input() MessageToShow: any = {};
  @Input() showMessage: boolean = false;
  @Input() url: string = '';
  @Input() msg: string = '';
  @Input() filename: string = '';
  isLoading : boolean = false;
  bomboq_url: string = "";
  bomboq_flag: boolean = false;
  
  constructor(private toastr: ToastrService,
    private apiService: ApiService,
    private spinner: NgxSpinnerService) { 
  }

  ngOnInit() {
 }

  trigger_bomboq(){
    this.isLoading = true;
    this.spinner.show();
    let payload = {
      'url':this.url,
      'filename':this.filename
    }
    this.apiService.initiateBOMBOQ(payload).subscribe({
      next: (response) => {
             if ('file_name' in response) {
                this.bomboq_flag = true;
                this.bomboq_url = response.bomboq_url
                this.MessageToShow = response;
              } else {
                this.toastr.error(response.message, 'Error Message');
                console.log('error');
              }
            
            this.isLoading = false;
            this.spinner.hide();
      },
      error: (error) => {
            this.isLoading = false;
            this.spinner.hide();
            this.toastr.error(
              `The API returned Unsuccessfull response : ${error}`,
              'Error Message'
            );
            //window.alert(`The API returned Unsuccessfull response : ${error}`);
          },
    });
  }

}
